import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { base_url } from "../context/Authcontext";
import "../../src/assets/AdminCss/dropdown.css";

export const Sidebar = ({ isSidebar }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if the device is mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkMobile();

    // Add event listener for window resize
    window.addEventListener("resize", checkMobile);

    // Clean up event listener
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleSideLink = () => {
    toast.success("Coming Soon");
  };

  return (
    <>
      <div _ngcontent-jrx-c95="" id="sidebar-landing" className="sidebar">
        <app-sidebar
          _ngcontent-jrx-c95=""
          _nghost-jrx-c79=""
          className="ng-star-inserted"
        >
          <nav
            _ngcontent-jrx-c79=""
            id="sidebar"
            className="collapse show showMargin"
            style={{
              transform: isSidebar ? "translateX(0%)" : "translateX(-100%)",
              transition: "transform 0.3s ease-in-out",
              height: isMobile ? "142vh" : "100vh", // Set height to viewport height
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div _ngcontent-jrx-c79="" className="sidebar-header">
              <a
                _ngcontent-jrx-c79=""
                routerlink="/home"
                className="d-flex align-items-center"
                style={{ textDecoration: "none" }}
                href="/"
              >
                <img
                  _ngcontent-jrx-c79=""
                  className="top_light"
                  src="/assets/images/Kheloyar-Logo-for-light-theme.png"
                  alt="Logo_Kheloyaar360"
                />
                <img
                  _ngcontent-jrx-c79=""
                  className="top_dark"
                  src="/assets/images/bigshot11logonew.png"
                  alt="Logo_Kheloyaar360"
                />
              </a>
            </div>
            <ul
              _ngcontent-jrx-c79=""
              id="sidebar-links"
              className="sidebar-links sidebar-list components ng-star-inserted"
              style={{
                transform: isSidebar ? "translateX(0%)" : "translateX(-100%)",
                transition: "transform 0.3s ease-in-out",
              }}
            >
              {/* <div _ngcontent-jrx-c79="" id="serachx" className="search-box">
                <div _ngcontent-jrx-c79="" className="search">
                  <input
                    _ngcontent-jrx-c79=""
                    list="list"
                    type="text"
                    placeholder="Search Market.."
                    id="list"
                    autoComplete="off"
                    className="search-txt ng-untouched ng-pristine ng-valid"
                  />
                </div>
                <div _ngcontent-jrx-c79="" className="list-cont">
                  <div _ngcontent-jrx-c79="" className="list-sugg"></div>
                </div>
              </div> */}
              {/* <div className="search-container">
  <input 
    type="text" 
    placeholder="Search Market.." 
    className="search-input" 
  />
</div> */}
              <b></b>
              <div _ngcontent-jrx-c79="" className="sec_sidebar">
                {/* <div
                  _ngcontent-jrx-c79=""
                  className="d-flex align-items-center justify-content-between market-border height_ext ng-star-inserted"
                  style={{ position: "relative" }}
                  tabIndex="0"
                  onClick={() => navigate("/cricketreal")}
                >
                  <label _ngcontent-jrx-c79="" className="mb-1 topsidebar">
                    <img
                      _ngcontent-jrx-c79=""
                      src="/assets/sidebar/s1.svg"
                      alt="All Casinos_Kheloyaar360"
                    />
                    <span _ngcontent-jrx-c79="" className="special-list fs-5 hover:text-lg  transition-all duration-200">
                      {" "}
                      Cricket
                    </span>
                  </label>
                </div> */}

                <div className="dropdown-container">
                  <div
                    _ngcontent-jrx-c79=""
                    className="d-flex align-items-center justify-content-between market-border height_ext"
                    style={{ position: "relative" }}
                    tabIndex="0"
                    onClick={() => navigate("/virtual")}
                  >
                    <label _ngcontent-jrx-c79="" className="mb-1 topsidebar">
                      <img
                        _ngcontent-jrx-c79=""
                        src="/assets/sidebar/s2.png"
                        alt="Sports_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c79="" className="special-list hover:text-lg  transition-all duration-200 fs-5">
                        {" "}
                        Virtual Sports
                      </span>
                    </label>
                  </div>
                </div>

                {/* <div
                  _ngcontent-jrx-c79=""
                  className="d-flex align-items-center justify-content-between market-border height_ext"
                  style={{ position: "relative" }}
                  tabIndex="0"
                  onClick={()=>navigate("/spribeHome")}
                >
                  <label _ngcontent-jrx-c79="" className="mb-1 topsidebar" style={{alignItems:'center'}}>
                    <img
                      _ngcontent-jrx-c79=""
                      src="/spribe_games/SPRIBE.png"
                      alt="Sports_Kheloyaar360"
                      style={{height:'1.1rem'}}
                    />
                    <span _ngcontent-jrx-c79="" className="special-list fs-5">
                      {" "}
                    Spribe
                    </span>
                  </label>
                </div> */}

                <div
                  _ngcontent-jrx-c79=""
                  className="d-flex align-items-center justify-content-between market-border height_ext"
                  style={{ position: "relative" }}
                  tabIndex="0"
                  onClick={()=>navigate("/casinoGames")}
                >
                  <label
                    _ngcontent-jrx-c79=""
                    className="mb-1 topsidebar"
                    style={{ alignItems: "center" }}
                  >
                    <img
                      _ngcontent-jrx-c79=""
                      src="/assets/sidebar/s3.png"
                      alt="Sports_Kheloyaar360"
                      style={{ height: "1.1rem" }}
                    />
                    <span _ngcontent-jrx-c79="" className="special-list fs-5 hover:text-lg  transition-all duration-200">
                      {" "}
                      All Casinos
                    </span>
                  </label>
                </div>

                <div
                  _ngcontent-jrx-c79=""
                  className="d-flex align-items-center justify-content-between market-border height_ext"
                  style={{ position: "relative" }}
                  tabIndex="0"
                  onClick={() => navigate("/sportAll")}
                >
                  <label
                    _ngcontent-jrx-c79=""
                    className="mb-1 topsidebar"
                    style={{ alignItems: "center" }}
                  >
                    <img
                      _ngcontent-jrx-c79=""
                      src="/assets/sidebar/s4.svg"
                      alt="Sports_Kheloyaar360"
                      style={{ height: ".9rem" }}
                    />
                    <span _ngcontent-jrx-c79="" className="special-list fs-5 hover:text-lg  transition-all duration-200">
                      {" "}
                      Sports
                    </span>
                  </label>
                </div>
              </div>
              <div _ngcontent-jrx-c79="" className="title_sidebar" tabIndex="0">
                <span _ngcontent-jrx-c79=""></span>
              </div>
              <div _ngcontent-jrx-c79="" className="sec_sidebar">
                <li
                  _ngcontent-jrx-c79=""
                  className="ng-star-inserted"
                  onClick={() => navigate("/cricketreal")}
                >
                  <div
                    _ngcontent-jrx-c79=""
                    className="d-flex align-items-center justify-content-between market-border height_ext"
                  >
                    <label
                      _ngcontent-jrx-c79=""
                      data="a"
                      htmlFor="4"
                      className="item"
                    >
                      <span
                        _ngcontent-jrx-c79=""
                        className="sports-icon-grey sports4"
                      >
                        <img
                          className="bigsize"
                          src="/assets/sidebar/s5.svg"
                          alt="nothing"
                        ></img>
                      </span>
                      <div className="d-flex gappp ">
                        {" "}
                        <span _ngcontent-jrx-c79="" className="first-level hover:text-lg  transition-all duration-200">
                          Cricket
                        </span>
                        {/* <i
                          _ngcontent-jrx-c79=""
                          className=" bi bi-chevron-down fs-15"
                        ></i> */}
                      </div>
                    </label>
                  </div>
                  <ul
                    _ngcontent-jrx-c79=""
                    data-check="1"
                    id="list-1"
                    className="list-1 sidebar-links"
                  ></ul>
                </li>
                <li
                  _ngcontent-jrx-c79=""
                  className="ng-star-inserted"
                  onClick={() => navigate("/footballreal")}
                >
                  <div
                    _ngcontent-jrx-c79=""
                    className="d-flex align-items-center justify-content-between market-border height_ext"
                  >
                    <label
                      _ngcontent-jrx-c79=""
                      data="a"
                      htmlFor="4"
                      className="item"
                    >
                      <span
                        _ngcontent-jrx-c79=""
                        className="sports-icon-grey sports4"
                      >
                        <img
                          className="bigsize"
                          src="/assets/sidebar/s6.svg"
                          alt="nothing"
                        ></img>
                      </span>
                      <div className="d-flex  gappp">
                        {" "}
                        <span _ngcontent-jrx-c79="" className="first-level hover:text-lg  transition-all duration-200">
                          Soccer
                        </span>
                        {/* <i
                          _ngcontent-jrx-c79=""
                          className="  bi bi-chevron-down fs-15"
                        ></i> */}
                      </div>
                    </label>
                  </div>
                  <ul
                    _ngcontent-jrx-c79=""
                    data-check="1"
                    id="list-1"
                    className="list-1 sidebar-links"
                  ></ul>
                </li>
                {/* <li
                  _ngcontent-jrx-c79=""
                  className="ng-star-inserted"
                  onClick={handleSideLink}
                >
                  <div
                    _ngcontent-jrx-c79=""
                    className="d-flex align-items-center justify-content-between market-border height_ext"
                  >
                    <label
                      _ngcontent-jrx-c79=""
                      data="a"
                      htmlFor="4"
                      className="item"
                    >
                      <span
                        _ngcontent-jrx-c79=""
                        className="sports-icon-grey sports4"
                      >
                        <img
                          className="bigsize"
                          src="/assets/sidebar/s7.webp"
                          alt="nothing"
                        ></img>
                      </span>
                      <div className="d-flex   gappp">
                        {" "}
                        <span _ngcontent-jrx-c79="" className="first-level hover:text-lg  transition-all duration-200">
                          Soccer Fixture
                        </span>
                        <i
                          _ngcontent-jrx-c79=""
                          className="  bi bi-chevron-down fs-15"
                        ></i>
                      </div>
                    </label>
                  </div>
                  <ul
                    _ngcontent-jrx-c79=""
                    data-check="1"
                    id="list-1"
                    className="list-1 sidebar-links"
                  ></ul>
                </li> */}
                <li
                  _ngcontent-jrx-c79=""
                  className="ng-star-inserted"
                  onClick={() => navigate("/tennisreal")}
                >
                  <div
                    _ngcontent-jrx-c79=""
                    className="d-flex align-items-center justify-content-between market-border height_ext"
                  >
                    <label
                      _ngcontent-jrx-c79=""
                      data="a"
                      htmlFor="4"
                      className="item"
                    >
                      <span
                        _ngcontent-jrx-c79=""
                        className="sports-icon-grey sports4"
                      >
                        <img
                          className="bigsize"
                          src="/assets/sidebar/s8.webp"
                          alt="nothing"
                        ></img>
                      </span>
                      <div className="d-flex   gappp">
                        {" "}
                        <span _ngcontent-jrx-c79="" className="first-level hover:text-lg  transition-all duration-200">
                          Tennis
                        </span>
                        {/* <i
                          _ngcontent-jrx-c79=""
                          className="  bi bi-chevron-down fs-15"
                        ></i> */}
                      </div>
                    </label>
                  </div>
                  <ul
                    _ngcontent-jrx-c79=""
                    data-check="1"
                    id="list-1"
                    className="list-1 sidebar-links"
                  ></ul>
                </li>
                <li
                  _ngcontent-jrx-c79=""
                  className="ng-star-inserted"
                  onClick={handleSideLink}
                >
                  <div
                    _ngcontent-jrx-c79=""
                    className="d-flex align-items-center justify-content-between market-border height_ext"
                  >
                    <label
                      _ngcontent-jrx-c79=""
                      data="a"
                      htmlFor="4"
                      className="item"
                    >
                      <span
                        _ngcontent-jrx-c79=""
                        className="sports-icon-grey sports4"
                      >
                        <img
                          className="bigsize"
                          src="/assets/sidebar/s9.webp"
                          alt="nothing"
                        ></img>
                      </span>
                      <div className="d-flex   gappp">
                        {" "}
                        <span _ngcontent-jrx-c79="" className="first-level hover:text-lg  transition-all duration-200">
                          Horse Racing
                        </span>
                        {/* <i
                          _ngcontent-jrx-c79=""
                          className="  bi bi-chevron-down fs-15"
                        ></i> */}
                      </div>
                    </label>
                  </div>
                  <ul
                    _ngcontent-jrx-c79=""
                    data-check="1"
                    id="list-1"
                    className="list-1 sidebar-links"
                  ></ul>
                </li>
                {/* <li
                  _ngcontent-jrx-c79=""
                  className="ng-star-inserted"
                  onClick={handleSideLink}
                >
                  <div
                    _ngcontent-jrx-c79=""
                    className="d-flex align-items-center justify-content-between market-border height_ext"
                  >
                    <label
                      _ngcontent-jrx-c79=""
                      data="a"
                      htmlFor="4"
                      className="item"
                    >
                      <span
                        _ngcontent-jrx-c79=""
                        className="sports-icon-grey sports4"
                      >
                        <img
                          className="bigsize"
                          src="/assets/sidebar/s.webp"
                        ></img>
                      </span>
                      <div className="d-flex   gappp">
                        {" "}
                        <span _ngcontent-jrx-c79="" className="first-level">
                          Horse Race Today Card
                        </span>
                        <i
                          _ngcontent-jrx-c79=""
                          className="  bi bi-chevron-down fs-15"
                        ></i>
                      </div>
                    </label>
                  </div>
                  <ul
                    _ngcontent-jrx-c79=""
                    data-check="1"
                    id="list-1"
                    className="list-1 sidebar-links"
                  ></ul>
                </li>
                <li
                  _ngcontent-jrx-c79=""
                  className="ng-star-inserted"
                  onClick={handleSideLink}
                >
                  <div
                    _ngcontent-jrx-c79=""
                    className="d-flex align-items-center justify-content-between market-border height_ext"
                  >
                    <label
                      _ngcontent-jrx-c79=""
                      data="a"
                      htmlFor="4"
                      className="item"
                    >
                      <span
                        _ngcontent-jrx-c79=""
                        className="sports-icon-grey sports4"
                      >
                        {" "}
                        <img
                          className="bigsize"
                          src="https://daba.b-cdn.net/images1/grey-hound.png"
                        ></img>{" "}
                      </span>
                      <div className="d-flex   gappp">
                        {" "}
                        <span _ngcontent-jrx-c79="" className="first-level">
                          Greyhound Racing
                        </span>
                        <i
                          _ngcontent-jrx-c79=""
                          className="  bi bi-chevron-down fs-15"
                        ></i>
                      </div>
                    </label>
                  </div>
                  <ul
                    _ngcontent-jrx-c79=""
                    data-check="1"
                    id="list-1"
                    className="list-1 sidebar-links"
                  ></ul>
                </li>
                <li
                  _ngcontent-jrx-c79=""
                  className="ng-star-inserted"
                  onClick={handleSideLink}
                >
                  <div
                    _ngcontent-jrx-c79=""
                    className="d-flex align-items-center justify-content-between market-border height_ext"
                  >
                    <label
                      _ngcontent-jrx-c79=""
                      data="a"
                      htmlFor="4"
                      className="item"
                    >
                      <span
                        _ngcontent-jrx-c79=""
                        className="sports-icon-grey sports4"
                      >
                        {" "}
                        <img
                          className="bigsize"
                          src="https://daba.b-cdn.net/images1/grey-hound.png"
                        ></img>
                      </span>
                      <div className="d-flex   gappp">
                        {" "}
                        <span _ngcontent-jrx-c79="" className="first-level">
                          Greyhound Todays Card
                        </span>
                        <i
                          _ngcontent-jrx-c79=""
                          className="  bi bi-chevron-down fs-15"
                        ></i>
                      </div>
                    </label>
                  </div>
                  <ul
                    _ngcontent-jrx-c79=""
                    data-check="1"
                    id="list-1"
                    className="list-1 sidebar-links"
                  ></ul>
                </li> */}
              </div>
              <div className="social-links-wrap  ">
                <a href={"#"} className="on-hover-action">
                  <div style={{borderBottom:"1px solid black"}} className="sociallink wp-bg p-3 ">
                    <i
                      className="fab fa-whatsapp"
                      style={{ fontSize: "20px", color:"black" }}
                    ></i>
                    <span className="social-1 text-black p-1">Get ID on WhatsApp</span>
                  </div>
                </a>
                <a
                  href={
                    "https://www.instagram.com/official_bigshot11?igsh=MW5yeWwzcHk2enZjNQ=="
                  }
                  className="on-hover-action"
                >
                  <div style={{borderBottom:"1px solid black"}} className="sociallink insta-bg p-3">
                    <i
                      className="fab fa-instagram"
                      style={{ fontSize: "20px" , color:"black" }}
                    ></i>
                    <span className="social-2 text-black"> Follow us on Instagram</span>
                  </div>
                </a>
                <a style={{borderBottom:"1px solid black"}} href={"#"} className="on-hover-action">
                  <div className="sociallink tel-bg p-3">
                    <i
                      className="fab fa-telegram-plane"
                      style={{ fontSize: "20px", color:"black" }}
                    ></i>
                    <span className="social-1 text-black "> Follow us on Telegram</span>
                  </div>
                </a>
              </div>
            </ul>
          </nav>
        </app-sidebar>
      </div>
    </>
  );
};
